import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-help-account',
    templateUrl: './help-account.component.html',
    styleUrls: ['./help-account.component.css'],
    standalone: false
})
export class HelpAccountComponent implements OnInit {

  // images
  @Input() getImgs: string[] = [];
  @Output() showImg: EventEmitter<string> = new EventEmitter<string>();

  constructor() {

  }

  ngOnInit(): void {
    console.log("Umm", this.getImgs);
  }

  // show selected image on screen
  showImage(url: string): void {
    this.showImg.emit(url);
  }

}
